<template>
  <div v-if="activeStep">
    <div class="custom-onboarding-overlay" @click="$emit('close')" />

    <b-popover
      :key="activeStep.target"
      :target="activeStep.target"
      :show="true"
      placement="bottom"
      triggers="manual"
      boundary="viewport"
      container="body"
      custom-class="custom-popover"
    >
      <div class="custom-popover-body">
        <p>{{ activeStep.content }}</p>
        <div class="d-flex justify-content-between align-items-center mt-2">
          <div class="cursor-pointer d-flex align-items-center text-muted" @click="$emit('disable')">
            <v-icon name="buttons/check" class="mr-1" :size="12" />
            <small style="font-size: 12px;">Больше не подсказывать</small>
          </div>
          <b-button class="custom-btn-primary" @click="$emit('next')">
            {{ isLastStep ? 'Ок' : 'Далее' }}
          </b-button>
        </div>
      </div>
    </b-popover>
  </div>
</template>

<script>
export default {
  props: {
    step: { type: Number, required: true },
    stepsConfig: { type: Array, required: true }
  },
  computed: {
    activeStep() {
      return this.stepsConfig.find(s => s.id === this.step) || null;
    },
    isLastStep() {
      const maxId = Math.max(...this.stepsConfig.map(s => s.id));
      return this.step === maxId;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/utilites/commonUi/Onboarding.vue